import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { ToastrService } from 'ngx-toastr';
import { Store, select } from '@ngrx/store';
import { AppState } from 'src/app/shareModule/states/app.state';
import { selectUser } from 'src/app/shareModule/states/user-details';

@Component({
  selector: 'app-advanced-settings-tags',
  templateUrl: './advanced-settings-tags.component.html',
  styleUrls: [
    './advanced-settings-tags.component.scss',
    '../advanced-settings.component.scss',
  ],
})
export class AdvancedSettingsTagsComponent implements OnInit {
  validSubscription: boolean;
  constructor(
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
    public commonService: CommonService,
    private customerService: CustomerService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.store.pipe(select(selectUser)).subscribe((user: any) => {
      this.validSubscription = user?.subscription != null;
      this.cdr.detectChanges();
    });
  }

  ngAfterViewInit(): void {}

  public ignoreTag(tag) {
    this.customerService.updateTag({ ignoreTag: tag }).subscribe(() => {
      this.toastr.success('Tag remove successfully');
      this.commonService.getTagList();
    });
  }
}
